export default __webpack_public_path__ + "static/share-2542ec1b3e372adfc9d645796c42a8f1.jpg";